<script>
import { COLOR } from '@/scripts/colorTheme.js';
import constants from '@/constants';
import { validateAllSettings } from '@/utils/systemSettingsValidator.js';

export default {
    data() {
        return {
            isSaving: false,
            isResettingToDefaults: false,
        };
    },
    computed: {
        hasChanges() {
            return this.$store.getters.HAS_UNSAVED_CHANGES;
        },
        isSaveDisabled() {
            return !this.hasChanges || this.isSaving;
        },
    },
    methods: {
        async handleSave() {
            if (this.isSaving) return;

            // Validate all settings before saving
            const settings = this.$store.getters.SYSTEM_SETTINGS;
            const errors = validateAllSettings(settings);

            if (errors.length > 0) {
                this.$store.commit('POPUP_ADD', {
                    color: COLOR.RED,
                    text: `Ошибки валидации:\n${errors.join('\n')}`,
                });
                return;
            }

            this.isSaving = true;
            try {
                await this.$store.dispatch('saveSystemSettings');
                // Success popup shown automatically by axiosRequest
            } finally {
                this.isSaving = false;
            }
        },

        handleReset() {
            this.$store.dispatch('resetToOriginal');
        },

        confirmResetToDefaults() {
            this.$store.commit(
                'CONFIRMED_POPUP_MESSAGE',
                '⚠️ Это сбросит ВСЕ системные настройки к значениям по умолчанию. Изменения сразу затронут всех пользователей. Продолжить?'
            );
            this.$store.commit(
                'CONFIRMED_POPUP_METHOD',
                this.executeResetToDefaults.bind(this)
            );
            this.$store.commit(
                'SHOP_POPUP_NAME',
                constants.POPUPS_NAME.CONFIRMED
            );
        },

        async executeResetToDefaults() {
            if (this.isResettingToDefaults) return;

            this.isResettingToDefaults = true;
            try {
                await this.$store.dispatch('resetToDefaults');
                // Success popup shown automatically by axiosRequest
            } finally {
                this.isResettingToDefaults = false;
            }
        },
    },
};
</script>

<template>
    <div class="actions_container">
        <button
            class="cursor_pointer_label save_button"
            @click="handleSave"
            :disabled="isSaveDisabled"
        >
            {{ isSaving ? 'Сохранение...' : 'Сохранить' }}
        </button>
        <button
            class="cursor_pointer_label reset_button"
            @click="handleReset"
            :disabled="!hasChanges || isSaving"
        >
            Отменить изменения
        </button>
        <button
            class="cursor_pointer_label defaults_button"
            @click="confirmResetToDefaults"
            :disabled="isSaving || isResettingToDefaults"
        >
            {{ isResettingToDefaults ? 'Сброс...' : 'Сбросить к значениям по умолчанию' }}
        </button>
    </div>
</template>

<style scoped>
.actions_container {
    position: sticky;
    bottom: 0;
    display: flex;
    gap: 10px;
    padding: 20px;
    justify-content: flex-end;
    background-color: var(--background);
    border-top: 1px solid var(--border-color);
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 10;
}

.save_button,
.reset_button,
.defaults_button {
    padding: 10px 20px;
    border-radius: 5px;
    border: 1px solid var(--border-color);
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    font-size: 14px;
}

.save_button {
    background-color: var(--main-color);
    color: white;
}

.save_button:hover:not(:disabled) {
    filter: brightness(0.9);
}

.save_button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.reset_button {
    background-color: var(--left-button);
    color: var(--left-button-text);
}

.reset_button:hover:not(:disabled) {
    background-color: var(--left-button-hover);
}

.reset_button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.defaults_button {
    background-color: #ff9800;
    color: white;
}

.defaults_button:hover:not(:disabled) {
    filter: brightness(0.9);
}

.defaults_button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
</style>
